
import Button from "../../../components/Buttons/Button";
import HomeBackground from "../../../components/HomeBackground/HomeBaground";
import { SECTIONIDS } from "../../../constants/sectionId";
import InfoListWidget from "../../../components/InfoList/InfoList";
import SocialsList from "../../../constants/socials";

const HeroSection = () => {
  return (
    <section
      id={SECTIONIDS.HERO}
      className="relative flex min-h-screen   items-center top-0"
    >
      <HomeBackground className="fixed z-0 inset-0 h-full w-full" />

      <div
        aria-hidden="true"
        className="absolute inset-0 z-0 bg-gradient-to-b from-black/10 via-black/20 to-black "
      />

      <div className="relative z-0 mx-auto max-w-7xl w-full px-6 pb-40 pt-60 lg:px-12 xl:px-6 2xl:px-0 ">
        <div className="pb-12 media-h:md:pb-32 media-h:lg:pb-12 xl:pb-12 ">
          <h1
            data-rellax-speed="-3"
            data-rellax-xs-speed="0 "
            data-rellax-mobile-speed="0"
            className="rellax text-6xl font-semibold text-gray-200 sm:text-8xl md:text-9xl xl:leading-tight uppercase"
            style={{ transform: "translate3d(0px, 0px, 0px)" }}
          >
            Erom Studio
          </h1>
        </div>
        <div>
          <div className="ml-auto md:w-2/3 md:pt-12 lg:w-1/2">
            <div className="flex gap-4">
              <p
                data-rellax-speed="-3"
                data-rellax-xs-speed="0 "
                data-rellax-mobile-speed="0"
                style={{ transform: "translate3d(0px, 0px, 0px)" }}
                className="rellax mb-20 24 text-xl font-light tracking-widest text-gray-300 sm:text-2xl md:text-5xl xl:leading-normal"
              >
                Design.
              </p>
              <p
                data-rellax-speed="-2"
                data-rellax-xs-speed="0 "
                data-rellax-mobile-speed="0"
                style={{ transform: "translate3d(0px, 0px, 0px)" }}
                className="rellax mb-20 24 text-xl font-light tracking-widest text-gray-300 sm:text-2xl md:text-5xl xl:leading-normal"
              >
                Develop.
              </p>
              <p
                data-rellax-speed="-1"
                data-rellax-xs-speed="0 "
                data-rellax-mobile-speed="0"
                style={{ transform: "translate3d(0px, 0px, 0px)" }}
                className="rellax mb-20 24 text-xl font-light tracking-widest text-gray-300 sm:text-2xl md:text-5xl xl:leading-normal"
              >
                Deliver.
              </p>
            </div>
            <Button
              label="See our Work"
              href={`#${SECTIONIDS.WORK}`}
              style={{ transform: "translate3d(0px, 0px, 0px)" }}
              className="rellax"
              rellaxData={{
                "data-rellax-speed": "-4",
                "data-rellax-xs-speed": "0",
                "data-rellax-mobile-speed": "0",
              }}
            />
          </div>
        </div>
        <div
          data-rellax-speed="-5"
          data-rellax-xs-speed="0"
          data-rellax-mobile-speed="0"
          className="rellax relative mt-16 ml-auto w-max md:mt32 md:ml-0 xl:-mt-16"
          style={{ transform: "translate3d(0px, 0px, 0px)" }}
        >
          <InfoListWidget infolist={SocialsList} />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
